import AddEditEntryModal from './AddEditEntryModal';

export default AddEditEntryModal;
